import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import cartsService from '../../services/carts';

const initialState = {
  loading: false,
  carts: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
    sort: undefined,
  },
  meta: {},
};

export const fetchCarts = createAsyncThunk('carts/fetchCarts', (params = {}) => {
  const { page, perPage, ...rest } = params;
  const query = {
    page: page ?? initialState.params.page,
    per_page: perPage ?? initialState.params.perPage,
    ...rest,
  };
  return cartsService.getAll(query).then((res) => res);
});

const cartsSlice = createSlice({
  name: 'carts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCarts.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCarts.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.carts = payload.data;
      state.meta = {
        total: payload.total,
        current_page: payload.current_page,
        per_page: Number(payload.per_page) || initialState.params.perPage,
      };
      state.params.page = payload.current_page;
      state.params.perPage = Number(payload.per_page) || state.params.perPage;
      state.error = '';
    });
    builder.addCase(fetchCarts.rejected, (state, action) => {
      state.loading = false;
      state.carts = [];
      state.error = action.error.message;
    });
  },
});

export default cartsSlice.reducer;

